export enum DurationUnit {
  MIN = 'min',
  H = 'h',
}

export const DurationUnitNames: Record<DurationUnit, string> = {
  [DurationUnit.MIN]: 'Minutes',
  [DurationUnit.H]: 'Hours',
};
